import React from "react"
import "../styles/logo.css"

import Layout from '../components/Layout'

export default function Home() {
  return (<>
      <Layout/>
  </>)
}